export default "__VITE_ASSET__CC7hRpjs__"